<template>
 <div>
      <v-tabs
        next-icon="arrow_forward_ios"
        prev-icon="arrow_back_ios"
        show-arrows
      >
       <v-tabs-slider></v-tabs-slider>
        <v-tab  class="primary--text" v-for="(tab,i) in tabs" :key="i+'tab'" @click="way=tab.way">
           <img :src="tab.img" :width="tab.width"/>
           &nbsp; &nbsp;{{tab.name}}
        </v-tab>
      </v-tabs>
      <Daily v-show="way=='daily'"/>
      <Statement v-show="way=='statement'"/>
  </div>
</template>

<script>
import Daily from '../report/Daily.vue';
import Statement from '../report/Statement.vue';
export default {
    components:{
        Daily,
        Statement
    },
    data(){
        return{
            way:'daily',
            tabs:[
                {name:"Daily",img:require('../assets/daily.png'),way:"daily",width:25},
                {name:"Statement",img:require('../assets/statement.png'),way:"statement",width:25},
            ]
        }
    },
    mounted(){
        let height = window.innerHeight - 210;
        let v_table = document.getElementsByClassName('v-table__overflow');
        for(let i =0;i<v_table.length;i++){
            v_table[i].style.height=height+"px"
        }


    }
}
</script>

